<div class="convert-834">
  <h1>Convert 834</h1>

  <div class="editor-header">
    <div class="label">Input</div>
    <div class="mode-actions">
      <button mat-button type="button" [disabled]="!inputIsJson" (click)="switchInputToText()">Text</button>
      <button mat-button type="button" [disabled]="inputIsJson" (click)="switchInputToJson()">JSON</button>
    </div>
  </div>

  <div *ngIf="inputIsJson; else textInput" class="json-editor-wrap">
    <json-editor [options]="inputEditorOptions" [data]="inputJson || {}" (change)="onInputJsonChanged($event)"></json-editor>
  </div>
  <ng-template #textInput>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Paste 834 or JSON</mat-label>
      <textarea
        matInput
        rows="16"
        [ngModel]="inputPayload"
        (ngModelChange)="onInputTextChanged($event)"
        placeholder="Paste EDI 834 text or JSON here"
      ></textarea>
    </mat-form-field>
  </ng-template>

  <div class="actions">
    <button mat-raised-button color="primary" [disabled]="isLoading" (click)="convertToJson()">
      Convert 834 -> JSON
    </button>
    <button mat-raised-button color="accent" [disabled]="isLoading" (click)="convertTo834()">
      Convert JSON -> 834
    </button>
  </div>

  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>

  <div class="editor-header">
    <div class="label">Response</div>
  </div>
  <div *ngIf="responseIsJson; else textResponse" class="json-editor-wrap">
    <json-editor [options]="outputEditorOptions" [data]="responseJson || {}"></json-editor>
  </div>
  <ng-template #textResponse>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Response</mat-label>
      <textarea matInput rows="16" [value]="responsePayload" readonly></textarea>
    </mat-form-field>
  </ng-template>
</div>
